import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import moment from 'moment';

// Google Analytics
// import 'googleAnalytics';
// console.log(ga);

// install router
Vue.use(VueRouter);

// install resource
Vue.use(VueResource);
// Vue.http.options.root = '/static/json';

// create router
const router = new VueRouter({
	// hashbang: false,
	// history: true,
	// saveScrollPosition: true,
	transitionOnLoad: true
});

// just for debugging
// window.router = router;

// dev mode
var devmode = false;
if (window.location.host === 'localhost:8080'){
	devmode = true;
}
// console.log('devmode: ' + devmode);

// var ua = navigator.userAgent;
// console.log(ua);

// configure router
var metaObj = {
	title: 'レンタル撮影スタジオ検索 studio DATA BASE by POWER PAGE - COMMERCIAL PHOTO',
	title_short: 'レンタル撮影スタジオ検索 studio DATA BASE by POWER PAGE',
	keywords: 'プロ のためのレンタル撮影スタジオ検索サイト',
	description: '全国の主要なスタジオを網羅したプロのためのレンタル撮影スタジオ検索サイト。白ホリからハウススタジオまで、所在地・料金・シチュエーション・設備で簡単検索。',
	url: encodeURIComponent(window.location),
	image: encodeURIComponent(window.location.protocol + '//' + window.location.host + '/static/images/pageHeader/pp_logo_ogp.png')
};
router.map({
	'/': {
		// 非同期でコンポーネントを読み込む
		component: function(resolve){
			require(['./components/top.vue'], resolve);
		},
		pageMeta: metaObj,
		isPage: false,
		devmode: devmode
	},
	'/searchresult': {
		name: 'searchresult',
		component: require('./components/searchresult.vue'),
		pageMeta: metaObj,
		isPage: true,
		devmode: devmode
	},
	'/favorites': {
		name: 'favorites',
		component: require('./components/favorites.vue'),
		pageMeta: metaObj,
		isPage: true,
		devmode: devmode
	},
	'/detail/:id': {
		component: require('./components/detail.vue'),
		pageMeta: metaObj,
		isPage: true,
		devmode: devmode
	}
});

// add components
Vue.component('my-nav', Vue.extend(require('./components/nav.vue')));
Vue.component('my-sidebar', Vue.extend(require('./components/sidebar.vue')));
Vue.component('my-footer', Vue.extend(require('./components/footer.vue')));
Vue.component('my-topicpath', Vue.extend(require('./components/topicpath.vue')));

// search components
Vue.component('my-searchwords', Vue.extend(require('./components/searchwords.vue')));
Vue.component('my-advancedsearch', Vue.extend(require('./components/advanced_search.vue')));
Vue.component('my-imagesearch', Vue.extend(require('./components/image_search.vue')));

// loading components
Vue.component('my-loading', Vue.extend(require('./components/loading_animation.vue')));

// custom directive
Vue.directive('my-preloadimg', function(obj){
	var self = this.el;
	var loader = self.getElementsByClassName('loader');
	var img = document.createElement('img');
	var alt = obj.alt === undefined ? '' : obj.alt;

	img.setAttribute('src', obj.src);
	img.setAttribute('alt', alt);
	if (obj.class !== undefined){
		// console.log(obj.class);
		for (var i = 0; i < obj.class.length; i++){
			img.classList.add(obj.class[i]);
		}
	}
	self.appendChild(img);

	img.onload = function(){
		// self.removeChild(loader[0]);
		loader[0].classList.add('hidden');
		img.classList.add('js-fadeIn');
	};
});

// custom filter
// integer
// 整数値にして返す
Vue.filter('integer', function(value){
	return parseInt(value, 10);
});

Vue.filter('encodeURI', function(value){
	return encodeURIComponent(value);
});

Vue.filter('nltobr', function(value){
	if (typeof (value) !== 'undefined'){
		var html = value.replace(/\r\n/, '<br>');
		return html;
	}
});

Vue.filter('brtonl', function(value){
	if (typeof (value) !== 'undefined'){
		var html = value.replace(/<br\s*\/?>/mg, '\r\n');
		return html;
	}
});

Vue.filter('wrap', function (value) {
	return '<div>' + value + '</div>';
});

Vue.filter('dateFormat', function (value) {
	return moment.unix(value).format('YYYY/MM/DD');
});

// boostrap the app
// コンポーネントはこれより前に定義する
var App = Vue.extend(require('../app.vue'));
router.start(App, '#app');

router.afterEach(function(transition){
	// console.log('from: ' + transition.from.path);
	// console.log('to: ' + transition.to.path);
});



// WEBPACK FOOTER //
// ./src/main.js